"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _actions = require("../../actions");

var _InlineSvg = _interopRequireDefault(require("../../../components/InlineSvg"));

var _helpers = require("../../../helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function TxtHandler(_ref) {
  var disabled = _ref.disabled,
      indexThreshold = _ref.indexThreshold,
      name = _ref.name,
      quadId = _ref.quadId;
  var dispatch = (0, _reactRedux.useDispatch)();

  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
    return state.universes;
  }),
      currentUniverse = _useSelector.currentUniverse;

  var _useSelector2 = (0, _reactRedux.useSelector)(function (state) {
    return state.campaignCreator;
  }),
      briefsFlow = _useSelector2.briefsFlow;

  function handleTxtGen(_x, _x2) {
    return _handleTxtGen.apply(this, arguments);
  }

  function _handleTxtGen() {
    _handleTxtGen = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee2(event, data) {
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              dispatch((0, _actions.getQuadrantMessagesDownload)(quadId, indexThreshold, currentUniverse)).then( /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee(response) {
                  var txtHeader, sectionsToDisplay, sections, data, today, fileName, url, link;
                  return _regenerator["default"].wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          txtHeader = [name + " " + response.quadrant.percentage.toFixed(1) + "% \n\n"]; //$FlowFixMe

                          if (indexThreshold !== null && indexThreshold > 0) {
                            //$FlowFixMe
                            txtHeader = [].concat(txtHeader, ["Index > " + indexThreshold + " \n\n"]);
                          }

                          sectionsToDisplay = response.sections;

                          if ((0, _helpers.isNZHelix)()) {
                            sectionsToDisplay.forEach(function (entry) {
                              entry.subsections = entry.subsections.filter(function (x) {
                                return x.label.toLowerCase() !== 'creative prerequisites' && x.label.toLowerCase() !== 'message prerequisites';
                              });
                              sectionsToDisplay.subsections = entry;
                            });
                          } else {
                            sectionsToDisplay = response.sections;
                          }

                          sections = sectionsToDisplay.reduce(function (messages, section) {
                            return [].concat(messages, section.subsections);
                          }, []).reduce(function (all, section) {
                            return [].concat(all, section.label, ['\n\n'], section.messages.join('\n\n'), ['\n\n\n']);
                          }, txtHeader).join('');
                          data = new Blob([sections], {
                            type: 'text/plain'
                          });
                          today = new Date().toLocaleDateString().split('/').join('');
                          fileName = "RoyMorgan_CreativeBrief_" + name.replace(/\s/, '') + "-" + today + ".txt";

                          if (window.navigator.msSaveBlob) {
                            window.navigator.msSaveBlob(data, fileName);
                          } else {
                            url = window.URL.createObjectURL(data);
                            link = document.createElement('a');
                            link.href = url;
                            link.download = fileName;
                            link.click();
                          }

                        case 9:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x3) {
                  return _ref2.apply(this, arguments);
                };
              }());

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return _handleTxtGen.apply(this, arguments);
  }

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("button", {
    disabled: disabled,
    className: "ui inverted button message-stream--pdf-link",
    onClick: handleTxtGen
  }, "Text", /*#__PURE__*/_react["default"].createElement(_InlineSvg["default"], {
    name: "file"
  })));
}

var _default = TxtHandler;
exports["default"] = _default;